import { useTranslation } from 'react-i18next';
import { DisplaySizePreview } from '../icons';
import { useDisplaySize } from '../../context/DisplaySizeContext';
import { DISPLAY_SIZES, DISPLAY_SIZE_LABEL_KEYS, DisplaySize } from '../../utils/displaySize';
import PreviewOptionGroup, { IPreviewOption } from '../previewOptionGroup/previewOptionGroup';

interface IDisplaySizeSwitcherProps {
  onSubmit?: () => void;
}

const DisplaySizeSwitcher = ({ onSubmit }: IDisplaySizeSwitcherProps) => {
  const { t } = useTranslation();
  const { displaySize, setDisplaySize } = useDisplaySize();

  const displaySizeOptions: IPreviewOption<DisplaySize>[] = DISPLAY_SIZES.map((size) => ({
    value: size,
    label: t(DISPLAY_SIZE_LABEL_KEYS[size]),
    preview: <DisplaySizePreview size={size} />,
    testId: `display-size-${size}`,
  }));

  const handleDisplaySizeChange = (size: DisplaySize) => {
    setDisplaySize(size);
    onSubmit?.();
  };

  return (
    <PreviewOptionGroup
      title={t('common:uiScale.title')}
      options={displaySizeOptions}
      value={displaySize}
      onChange={handleDisplaySizeChange}
      testId="display-size-radio"
    />
  );
};

export default DisplaySizeSwitcher;
